<template>
  <div class="r-submit-waste">
    <div v-show="isVisible">
      <div class="container" v-show="!isLastInputWaste">
        <step-navigation
          :navigationSteps="navigationSteps"
          :currentStep="currentStep"
          :validSteps="validSteps"
          @stepIdClick="onStepIdClick"
        />
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import StepNavigation from '@/components/StepNavigation/StepNavigation';
import { getLocalStorageItem } from '@/helpers/storage';
import submitWaste from './submit-waste.store';
import stepValidators from './StepValidators';
import CompositionsService from '@/services/Compositions/CompositionsService';

export default {
  data() {
    return {
      isVisible: false,
      currentPathName: '',
      navigationSteps: [
        {
          id: 1,
          label: 'Base Data',
        },
        {
          id: 2,
          label: 'Second Data',
        },
        {
          id: 3,
          label: 'Overview',
        }
      ],
      stepMap: {
        'submit-waste-base': [0, 1, 'Base Data'],
        'submit-waste-input': [1, 2, 'Contamination Data'],
        'submit-waste-output': [1, 2, 'Composition Data'],
        'submit-waste-input-overview': [2, 3, 'Contamination Overview'],
        'submit-waste-output-overview': [2, 3, 'Composition Overview'],
      },

      currentStep: 1,
    };
  },

  computed: {
    ...mapState({
      userCompanies: state => state.userCompanies.loggedUserCompanies,
      countries: state => state.countries.countries,
      validSteps: state => state.submitWaste.validSteps,
      isLastInputWaste: state => state.submitWaste.lastCompositionInput ? state.submitWaste.lastCompositionInput.id : 0,
      isInput: state => state.user.user.is_input,
    }),

  },

  watch: {
    '$route.name': {
      deep: true,
      handler(newValue) {
        this.currentPathName = newValue;
      }
    },
    currentPathName(newValue) {
      const [index, step, label] = this.stepMap[newValue];
      this.navigationSteps[index].label = label;
      this.currentStep = step;
    },
  },

  methods: {
    ...mapActions({
      getUserCompanies: 'userCompanies/getCompanies',
      getCountries: 'countries/getCountries',
    }),
    ...mapMutations({
      setBaseData: 'submitWaste/setBaseData',
      setLastCompositionInput: 'submitWaste/setLastCompositionInput',
      setInputCompositionWaste: 'submitWaste/setInputCompositionWaste',
    }),
    async onStepIdClick(stepId) {
      const routeMap = {
        1: 'submit-waste-base',
        2: this.isInput ? 'submit-waste-input' : 'submit-waste-output',
        3: this.isInput ? 'submit-waste-input-overview' : 'submit-waste-output-overview',
      };

      const valid = stepValidators.validate(stepId);
      if (await valid() === true && this.validSteps[stepId]) {
        this.$router.push({ name: routeMap[stepId] });
      }
    }
  },

  created() {
    this.$store.registerModule('submitWaste', submitWaste);
    this.currentPathName = this.$route.name;
    this.navigationSteps[1].label = this.isInput ? 'Contamination Data' : 'Composition Data';
    this.navigationSteps[2].label = this.isInput ? 'Contamination Overview' : 'Composition Overview';
  },

  async mounted() {

    await this.getUserCompanies(this.$store.getters['user/getLoggedInUserId']);
    await this.getCountries();
    const lastInput = getLocalStorageItem('last_input');
    this.isVisible = true;
    if (lastInput) {
      const { composition, submission } = lastInput;
      const { materials, company_id } = composition;
      const { country_code, collection_date } = submission;
      const { data } = await CompositionsService.getCompositionByType({
        company_id,
        type: 1,
      });

      if (data && data.composition) {
        const lastCompositionInput = data.composition.find((com) => {
          return com.name === composition.name;
        });
        this.setLastCompositionInput(lastCompositionInput);
        this.setInputCompositionWaste(data.composition);
      }

      const company = this.userCompanies.find((company) => {
        return company.id === composition.company_id;
      });

      const country = this.countries.find((countrie) => {
        return countrie.code === country_code;
      });

      if (company) {
        this.setBaseData({
          company,
          country,
          collection_date,
          material: materials[0],
        });
      }
    }

    if (this.isLastInputWaste && this.isInput) {
      this.$router.push({ name: 'submit-waste-input' });
    }
  },

  beforeDestroy() {

    this.$store.commit('submitWaste/resetState');
    this.$store.unregisterModule('submitWaste');
  },

  components: {
    'step-navigation': StepNavigation,
  }
};
</script>
